import * as React from 'react';
import {Button, Icon} from '@flexe/ui-components';
import DoWhenClickOutside from '../shared/DoWhenClickOutside';

interface UserDetailsProps {
  userName: string;
  changePasswordUrl: string;
  logoutUrl: string;
}

function UserDetails({userName, changePasswordUrl, logoutUrl}: UserDetailsProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="user-details">
      <Button visualType="icon" onPress={toggleDropdown}>
        <span className="name">{userName}</span>
        <Icon icon="user" />
      </Button>
      {isOpen && (
        <DoWhenClickOutside callback={() => setIsOpen(false)}>
          <div className="actions">
            <ul>
              <li>
                <a href={changePasswordUrl}>Change Password</a>
              </li>
              <li>
                <a href={logoutUrl}>Log Out</a>
              </li>
            </ul>
          </div>
        </DoWhenClickOutside>
      )}
    </div>
  );
}

export default UserDetails;
